import { useEffect, useRef, useState } from "react";
import Swiper from "swiper";
import { Navigation, Zoom } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/zoom";

const MenuLightbox = ({ images, initialIndex, onClose }) => {
	const swiperRef = useRef(null);
	const [current, setCurrent] = useState(initialIndex);

	// Lock body scroll while open
	useEffect(() => {
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = "";
		};
	}, []);

	useEffect(() => {
		swiperRef.current = new Swiper(".lightbox-swiper", {
			modules: [Navigation, Zoom],
			slidesPerView: 1,
			initialSlide: initialIndex,
			loop: images.length > 1,
			spaceBetween: 20,
			zoom: { maxRatio: 4 },
			navigation: {
				nextEl: ".lightbox-swiper .swiper-button-next",
				prevEl: ".lightbox-swiper .swiper-button-prev",
			},
		});

		swiperRef.current.on("slideChange", (swiper) => {
			setCurrent(swiper.realIndex);
		});

		return () => {
			swiperRef.current?.destroy(true, true);
			swiperRef.current = null;
		};
	}, []);

	return (
		<div className="lightbox-overlay">
			<button className="lightbox-close" onClick={onClose} aria-label="Chiudi">
				×
			</button>

			<div className="lightbox-swiper swiper">
				<div className="swiper-wrapper">
					{images.map((img) => (
						<div key={img.id} className="swiper-slide lightbox-slide">
							<div className="swiper-zoom-container">
								<img src={img.url} alt="" className="lightbox-img" />
							</div>
						</div>
					))}
				</div>
				{images.length > 1 && (
					<>
						<div className="swiper-button-prev"></div>
						<div className="swiper-button-next"></div>
					</>
				)}
			</div>

			{images.length > 1 && (
				<p className="lightbox-hint">
					{current + 1} / {images.length}
				</p>
			)}
		</div>
	);
};

export default MenuLightbox;
